import { TABLET_MAX_WIDTH, TABLET_PORTRAIT_MAX_WIDTH } from 'constants/styles';

export const isTabletPortrait = () => window.innerWidth <= TABLET_PORTRAIT_MAX_WIDTH;

const isTablet = () => window.innerWidth <= TABLET_MAX_WIDTH;

export default isTablet;
